import React, { useState, useEffect } from "react";
// import { useForm } from "react-final-form";
import { Button } from "react-admin";
import IconContentAdd from "@material-ui/icons/Add";
import IconCancel from "@material-ui/icons/Cancel";
import IconSave from "@material-ui/icons/Save";

import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import dataProvider from "../../utils/apiService";

function SendAppNotificationDialog(props) {
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [form, setForm] = useState({
    title: "",
    text: "",
    url: null,
    image_url: "",
  });

  const { title, text, url, image_url } = form;
  const { data } = props;
  useEffect(() => {
    if (data && data.title) {
      setForm({
        title: data.title,
        text: data.title,
        image_url: data.img_url,
      });
    }
  }, [data]);

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
  const handleSubmit = () => {
    setLoading(true);
    const obj = {
      data: {
        title: title,
        text: text,
        image: image_url,
        url: url,
        notificationId: data.id,
      },
    };
    dataProvider.post("fcm/push-app-notification", obj).then((res) => {
      setLoading(false);
      setShowDialog(false);
      setOpenSnackBar(true);
    });
  };

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  const onChange = (e) => {
    // console.log(e.target.name);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        label="Send App Notification"
      >
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
      >
        <DialogTitle>Notification</DialogTitle>

        {data && data.title && (
          <form style={{ padding: "16px" }}>
            <DialogContent>
              <Box>
                <TextField
                  label="Notification Title"
                  variant="filled"
                  value={title}
                  name="title"
                  onChange={onChange}
                  source="notification-title"
                  required
                  fullWidth
                />
              </Box>
              <Box my={6}>
                <TextField
                  label="Notification Text"
                  variant="filled"
                  value={text}
                  name="text"
                  onChange={onChange}
                  source="notification-text"
                  fullWidth
                  multiline
                />
              </Box>
              <Box my={6}>
                <TextField
                  label="Image URL to be shown on notification bar"
                  variant="filled"
                  value={image_url}
                  name="image_url"
                  onChange={onChange}
                  source="notification-image_url"
                  fullWidth
                  multiline
                />
              </Box>
              <Box my={6}>
                <TextField
                  label="Screen Mapped To Url (Deep Linked Url - Optional)"
                  variant="filled"
                  value={url}
                  name="url"
                  onChange={onChange}
                  source="notification-url"
                  fullWidth
                  multiline
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                label="ra.action.cancel"
                onClick={handleCloseClick}
                disabled={loading}
              >
                <IconCancel />
              </Button>
              <Button
                title="Send"
                label="Send App Notification"
                onClick={handleSubmit}
                disabled={loading}
              >
                <IconSave />
              </Button>
              {/* <SaveButton
                title="Send"
                label="Send Notification"
                handleSubmitWithRedirect={handleSubmit}
                //   pristine={pristine}
                //   onSave={handleSubmit}
                saving={saving}
                disabled={loading}
              /> */}
            </DialogActions>
          </form>
        )}
      </Dialog>
      <Snackbar
        // open={true}
        open={openSnackBar}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
      >
        <Box
          style={{
            backgroundColor: "#e83f7d",
            // padding: "18px",
            borderRadius: "4px",
          }}
          mb={2}
          px={10}
          py={2}
        >
          Notification Sent !!!
        </Box>
      </Snackbar>
    </>
  );
}

export default SendAppNotificationDialog;
